import { createElement } from '../../core/dom/helpers.js';

/**
 * Create an inline error panel with optional retry button.
 *
 * @param {HTMLElement} container
 * @param {{ title?: string, message: string, onRetry?: () => void }} options
 * @returns {{ update: (message: string) => void, destroy: () => void }}
 */
export function createInlineError(container, { title, message, onRetry }) {
  const root = createElement('div', { class: 'inline-error' });

  if (title) {
    root.appendChild(createElement('h3', { class: 'inline-error-title' }, [title]));
  }

  const messageEl = createElement('p', { class: 'inline-error-message' }, [message]);
  root.appendChild(messageEl);

  if (onRetry) {
    const btn = createElement('button', { class: 'inline-error-retry', type: 'button' }, ['Retry']);
    btn.addEventListener('click', onRetry);
    root.appendChild(btn);
  }

  container.appendChild(root);

  /**
   * @param {string} newMessage
   */
  function update(newMessage) {
    messageEl.textContent = newMessage;
  }

  function destroy() {
    root.remove();
  }

  return { update, destroy };
}
